import { Box, CircularProgress } from '@mui/material';
import React from 'react';

interface SideDishLoaderProps {
}

const SideDishLoader: React.FC<SideDishLoaderProps> = ({ }) => {
    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} width={"100%"} height={200}>
            <CircularProgress />
        </Box>
    )
}

export default SideDishLoader;